import React, { useState, useEffect } from "react";
import {
  SquarePaymentsForm,
  CreditCardInput,
} from "react-square-web-payments-sdk";
import "react-square-payment-form/lib/default.css";
import { Modal, FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { jsonRequest } from "../../api/noTokenRequest";
import CancelIcon from "@material-ui/icons/Cancel";

const countPaidDivers = (drivers = []) => {
  let total = 0;

  // eslint-disable-next-line no-unused-expressions
  drivers?.forEach((driver) => {
    if (driver.payment_info !== null) {
      total += 1;
    }
  });

  return total;
};

export const TeamPaymentForm = ({
  show,
  team,
  eventId,
  cardNonceResponseReceived,
  handleCancelClick,
}) => {
  const [drivers, setDrivers] = useState("");
  const [crews, setCrews] = useState("");
  const [event, setEvent] = useState({});

  useEffect(() => {
    const rootWindow = window.parent;
    const prevX = rootWindow.scrollX;
    const prevY = rootWindow.scrollY;
    rootWindow.scrollTo(prevX, 0);
    return () => rootWindow.scrollTo(prevX, prevY);
  });

  useEffect(() => {
    jsonRequest(`event?id=${eventId}`).then((res) => setEvent(res));
  }, [eventId]);

  const calculateTotalPayment = (driversCount, crewsCount) => {
    const paidDrivers = countPaidDivers(team?.team_slots?.drivers);
    // const paidDrivers = 4;
    let allDiversPrice = 0;
    let allCrewsPrice = 0;

    const actualDrivers =
      paidDrivers === 0 ? event?.max_drivers : event?.max_drivers - paidDrivers;

    const actualDriversPrice = (event?.driver_price / 100) * actualDrivers;
    const actualCrewsPrice = (event?.crew_price / 100) * event?.max_crew;
    const actualCrews = event?.max_crew;

    if (driversCount === 0 && crewsCount === 0) {
      return 0;
    }

    if (driversCount <= actualDrivers) {
      const maxDriversPrice = (event?.driver_price / 100) * driversCount;
      allDiversPrice += maxDriversPrice;
    }

    if (driversCount > actualDrivers) {
      let extraDrivers = driversCount - actualDrivers;
      const value =
        actualDriversPrice + (event?.extra_driver_price / 100) * extraDrivers;

      allDiversPrice += value;
    }

    if (crewsCount <= event?.max_crew) {
      const maxCrewsPrice = (event?.crew_price / 100) * crewsCount;
      allCrewsPrice += maxCrewsPrice;
    }

    if (crewsCount > event?.max_crew) {
      let extraCrew = crewsCount - actualCrews;
      const value =
        actualCrewsPrice + (event?.extra_crew_price / 100) * extraCrew;
      allCrewsPrice += value;
    }

    return allDiversPrice + allCrewsPrice;
  };

  return (
    <Modal
      className="payment-process-team"
      show={show}
      onHide={handleCancelClick}
    >
      <Modal.Header className="bg-danger text-white">
        <Modal.Title>
          {" "}
          <span
            className="modal-title"
            style={{
              color: "white",
              height: "30px",
              fontWeight: "700",
              fontFamily: "Segoe UI",
              fontSize: "16px",
            }}
          >
            Payment
          </span>
        </Modal.Title>
        <CancelIcon
          onClick={handleCancelClick}
          style={{ color: "white", cursor: "pointer", outline: "none" }}
        />
      </Modal.Header>
      <Modal.Body>
        <FormGroup>
          <FormLabel>Number of Driver entries</FormLabel>
          <FormControl
            min={0}
            type="number"
            value={drivers}
            placeholder="0"
            onChange={(e) => setDrivers(parseInt(e.target.value))}
          />
        </FormGroup>

        <FormGroup>
          <FormLabel>Number of Crew entries</FormLabel>
          <FormControl
            min={0}
            type="number"
            value={crews}
            placeholder="0"
            onChange={(e) => setCrews(parseInt(e.target.value))}
          />
        </FormGroup>

        <FormGroup>
          <FormLabel>Total Payment</FormLabel>
          <FormControl
            type="number"
            placeholder="0"
            value={calculateTotalPayment(drivers, crews)}
            disabled
          />
        </FormGroup>
        <SquarePaymentsForm
          applicationId={team?.team_info?.pay_pub_key}
          cardTokenizeResponseReceived={(token) => {
            token.drivers = drivers;
            token.crews = crews;
            cardNonceResponseReceived(token, true);
          }}
          locationId={team?.team_info?.pay_location}
        >
          <CreditCardInput text="Pay now" />
        </SquarePaymentsForm>
      </Modal.Body>
    </Modal>
  );
};
